import { auth } from '@/auth';
import { PushHubClient } from './PushHubClient';

/**
 * Singleton SignalR-клиент для push-инвалидации lazy-счётчиков меню Задачи/Документы.
 * Сервер шлёт CountersInvalidated через pg_notify; клиент фильтрует payload локально.
 * При недоступности (404 / retry-fail) переходит в disabled — TTL бэкенда + opportunistic
 * refetch достаточны (push-fallback на polling здесь оверкилл). После окончательного обрыва
 * useFolderCounts поднимает хаб через ensureStarted при возврате во вкладку и online, а после
 * восстановления (onReconnected) перечитывает счётчики full-fetch'ем.
 */

export type FolderCountersInvalidatedPayload = {
    kind: 'tasks' | 'documents';
    op: 'INSERT' | 'UPDATE' | 'DELETE' | string;
    flowKey?: number | null;
    oldFlowKey?: number | null;
};

type InvalidatedCallback = (payload: FolderCountersInvalidatedPayload) => void;

class FolderCountersHubClient extends PushHubClient<FolderCountersInvalidatedPayload> {
    constructor() {
        super({
            name: 'FolderCountersHub',
            path: '/hubs/folderCounters',
            event: 'CountersInvalidated',
            isValidPayload: (payload) => typeof payload.kind === 'string',
        });
    }

    public onCountersInvalidated(callback: InvalidatedCallback): () => void {
        return this.subscribe(callback);
    }
}

export const folderCountersHub = new FolderCountersHubClient();

// Выход или вход другим пользователем закрывают соединение: иначе оно остаётся в группе
// прежнего пользователя, и вошедший в той же вкладке получал бы чужие события счётчиков.
auth.subscribe(({ origin, accessToken }) => {
    if (origin === 'login' || !accessToken) folderCountersHub.stop();
});
